import get from 'lodash/get.js';

export default class FilterEvent {
    constructor(capture) {
        this.event = capture.event;
        this.filter = capture.filter;
        this.attributes = {};

        Object.keys(capture)
            .filter(key => !['event', 'filter'].includes(key))
            .forEach(key => {
                this.setAttribute(key, capture[key]);
            });
    }

    setAttribute(field, value) {
        this.attributes[field] = value;
    }

    getAttribute(field) {
        return get(this.attributes, field);
    }
}
